import type { FilterSectionHeaderStatus } from ".";

export const hasEnabledOptions = (
	options: Array<{ disabled: boolean }>,
): boolean => options.some((option) => !option.disabled);

export const getSectionStatus = (
	options: Array<{ checked: boolean; disabled: boolean }>,
): FilterSectionHeaderStatus => {
	const enabled = options.filter((option) => !option.disabled);
	const checkedCount = enabled.filter((option) => option.checked).length;
	if (checkedCount === 0) {
		return "unchecked";
	}
	return checkedCount === enabled.length ? "checked" : "indeterminate";
};
